import ContinuePage from "@components/ContinuePage"

export default function CarsAlmostTherePage() {
  return <ContinuePage emoji="🏁" translationKey="carsAlmostThere" />
}
